export default __webpack_public_path__ + "static/media/corona-virus.9067e3ff.svg";